module.exports = __webpack_public_path__ + "img/myposition_cb.2b4f97e7.svg";